import type { SbBlokData } from "@storyblok/js";
import { storyblokEditable } from "@storyblok/js";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import type { PageStoryblok } from "@/types/blok-types";

const PageBlok = ({
  blok,
  preview
}: {
  blok: PageStoryblok;
  preview?: boolean;
}) => {
  return (
    <main key={blok._uid} {...storyblokEditable(blok as SbBlokData)}>
      {blok?.body
        ? blok?.body?.map((currentBlok, i) => {
            return (
              <StoryblokComponent
                blok={currentBlok}
                key={blok._uid + "-" + currentBlok._uid}
                firstElement={i === 0 ? true : false}
                preview={preview}
              />
            );
          })
        : null}
    </main>
  );
};

export default PageBlok;
